import React from 'react'
import Footer from '../../Components/footer'
import { Header } from '../../Components/partial/Header'
import BradCaump from '../../Components/partial/BradCaump'

const shop = () => {
  return (
    <>
        <Header/>
        <BradCaump/>


        <Footer/>        
    </>
  )
}

export default shop